/**
 * BlockSuite effects - registers custom elements and initializes BlockSuite
 * This must be imported early in the application lifecycle
 */

import { effects as blocksEffects } from '@blocksuite/blocks/effects'

/**
 * Register BlockSuite custom elements
 * Call this before any React rendering occurs
 */
export function initializeBlockSuiteEffects() {
  // Register all BlockSuite blocks and components effects
  // This will register all the necessary custom elements including:
  // - affine-page-root, affine-edgeless-root
  // - All block components (paragraph, note, etc.)
  // - All widgets and UI components
  blocksEffects()
}

// Auto-initialize when this module is imported
initializeBlockSuiteEffects()